<bn-partner-portal-sidebar
  [isMobileMenuOpened]="isMobileMenuOpened()"
  (toggleMenu)="onToggleMenu($event)" />

<main class="bn-pp-main">
  <section
    class="bn-pp-main__container bn-container {{ 'bn-container--' + contentService.containerSize() }}"
    [class.bn-container--disabled-transition]="contentService.isTransitionDisabled()">
    <router-outlet />
  </section>
</main>

<bn-layout-mobile-menu
  [isMobileMenuOpened]="isMobileMenuOpened()"
  [menuItems]="mobileMenuItems"
  (toggleMenu)="onToggleMenu($event)" />
